import { render, staticRenderFns } from "./NewRirekishoEdit.vue?vue&type=template&id=ec490386&scoped=true&"
import script from "./NewRirekishoEdit.vue?vue&type=script&lang=js&"
export * from "./NewRirekishoEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewRirekishoEdit.vue?vue&type=style&index=0&id=ec490386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec490386",
  null
  
)

export default component.exports